export default __webpack_public_path__ + "static/media/fj.e7d1824f.svg";